import { isLP } from '../../config';
import routes from '../../pages/routes';
import { generatePath } from '../router';
import {
    TrainingDataType,
    TrainingItemPath,
    TrainingMenuItemType,
} from './types';

export const TRAINING_URL = () =>
    isLP() ? '/training' : generatePath(routes.rental.training.path);
export const HOME_TRAINING_SLUG = 'welcome-alude';

export const getTrainingCurrentSlug = () => {
    if (typeof window === 'undefined') {
        return '';
    }
    return window.location.pathname.split('/').pop() ?? '';
};

const getMenuItemPathInternal = (
    item: TrainingMenuItemType,
    currentSlug: string
): TrainingItemPath[] => {
    if (item.content.slug.current === currentSlug) {
        return [{ title: item.title, slug: item.content.slug.current }];
    }
    if (item.children) {
        let resultPath = [] as TrainingItemPath[];
        item.children.forEach(child => {
            resultPath = resultPath.concat(
                getMenuItemPathInternal(child, currentSlug)
            );
        });
        if (resultPath.length > 0) {
            resultPath.push({
                title: item.title,
                slug: item.content.slug.current,
            });
        }
        return resultPath;
    }
    return [];
};

export const getMenuItemPath = (
    trainingMenu: TrainingDataType,
    currentSlug: string
) => {
    let reversedPath: TrainingItemPath[] = [];
    for (const group of trainingMenu.items) {
        group.items.map(item => {
            reversedPath = reversedPath.concat(
                getMenuItemPathInternal(item, currentSlug)
            );
        });
        if (reversedPath.length > 0) {
            reversedPath.push({ title: group.title, slug: undefined });
            break;
        }
    }
    return reversedPath.reverse();
};
